/**
 * The partner portal's sign-in session.
 *
 * Kept in sessionStorage (per tab, gone when the tab closes). The token is
 * written here directly, NOT through app-js/authToken: the staff console keeps
 * its login in localStorage, shared by every tab, so a partner sign-in or an
 * admin's view-only pass must never land there. `partner_session` records
 * WHO is signed in -- lender + DSA slug -- so the router can keep a partner on
 * /partner/<nbfc>/<own-slug> and nowhere else. The server re-checks the token
 * on every partner page (partner/auth/me/), so this is a guide, not the lock.
 */
const KEY = "partner_session";

export function readSession() {
  try {
    const s = JSON.parse(sessionStorage.getItem(KEY) || "null");
    return s && s.slug && s.nbfc_code && sessionStorage.getItem("token") ? s : null;
  } catch (e) {
    return null;
  }
}

/** This tab's partner token (read by partner-portal/http.js). */
export function storeToken(access, refresh, nbfcId) {
  sessionStorage.setItem("token", access || "");
  sessionStorage.setItem("rtoken", refresh || "");
  sessionStorage.setItem("nbfc_Id", nbfcId || "");
}

export function saveSession(res) {
  storeToken(res.token.access_token, res.token.refresh_token, res.X_NBFC_ID);
  sessionStorage.setItem(KEY, JSON.stringify(res.partner));
  sessionStorage.setItem("user_name", res.partner.name || "");
}

/** Who is signed in, as the server now names them: a DSA an admin renames gets a new
 *  slug, and the router must follow it rather than keep the tab on the old address. */
export function updateIdentity(partner) {
  try {
    const s = JSON.parse(sessionStorage.getItem(KEY) || "null");
    if (!s) return;
    sessionStorage.setItem(KEY, JSON.stringify({ ...s, slug: partner.slug, nbfc_code: partner.nbfc_code, name: partner.name }));
  } catch (e) {
    /* no storage: the tab keeps its address */
  }
}

export function clearSession() {
  sessionStorage.clear();
}

/** A lender's sign-in page. */
export function loginOf(nbfc) {
  return { name: "partner-login", params: { nbfc } };
}

/** Where a signed-in partner belongs. */
export function homeOf(session) {
  return { name: "partner-home", params: { nbfc: session.nbfc_code, dsa: session.slug } };
}
